import React, { useState, useEffect } from 'react';
import { Modal, Form, Input, Select, Button, Checkbox, Row, Col, notification, Tabs, Radio, Table, Divider, InputNumber, DatePicker, Tooltip } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import StudentLoader from '../common/student-loader';
import BatchLoader from '../common/batch-loader';
import GroupLoader from '../common/group-loader';
import StreamLoader from '../common/stream-loader';
import ClassDivisionLoader from '../common/class-division-loader';
import ResourceLevel from '../common/resource-level-loader';
import LabQuestionFilter from '../utils/lab-question-filters';
import { projectStacks, global_var } from '../../services/cs-lab-config';
import { isEqual } from 'lodash';
import { saveMaterialToResource, assignLabQuestion, fetchLabQuestionResource} from '../../services/ide-apis';
import { getIdeProjectTypeMetaData, trackEvent } from '../utils/util-functions';
import TinyMCEEditor from '../common/tinymce-editor-loader';
import dayjs from 'dayjs';
import SuccessModal from '../labAssignments/assigned-success-modal';
import AiQuestionsModal from '../labAssignments/ai-questions';
import { ReactComponent as AiIconRed } from '../../assets/logos/ai icon white.svg';
import "./create-assignment-modal.css"
import viewIcon from '../../assets/logos/viewSourceCode.svg';
import { ReactComponent as AiIconWhite } from '../../assets/logos/ai icon white.svg';
import ParaphraseAi from "../paraphraser/paraphrase-ai-modal";
import ModalComponent from '../labAssignments/assignment-details-modal';

const { TabPane } = Tabs;

const CreateAssignment = ({ visible, onCancel, onCreate, loading, hideClassFilter, hideStreamFilter }) => {

    const [form] = Form.useForm();
    const [isAiModalOpen, setIsAiModalOpen] = useState(false);
    const { Option } = Select;
    const [assignTo, setAssignTo] = useState("");
    const [successModalVisible, setSuccessModalVisible] = useState(false);
    const [dueDateChecked, setDueDateChecked] = useState(false);
    const [selectedStudent, setSelectedStudent] = useState([]);
    const [isOpenModal, setIsOpenModal] = useState(false);
    const [selectedProjectView, setSelectedProjectView] = useState([]);
    const [selectedLevel, setSelectedLevel] = useState(null);
    const [selectedBatch, setSelectedBatch] = useState([]);
    const [selectedGroup, setSelectedGroup] = useState([]);
    const [selectedClassDivision, setSelectedClassDivision] = useState([]);
    const [selectedClassDivisionStream, setSelectedClassDivisionStream] = useState([]);
    const [singleClassDivisionStream, setSingleClassDivisionStream] = useState([]);
    // const [image, setImage] = useState([]);
    // const [audio, setAudio] = useState([]);
    // const [imagePreview, setImagePreview] = useState([]);
    // const [audioPreview, setAudioPreview] = useState([]);
    // const [video, setVideo] = useState([]);
    // const [videoPreview, setVideoPreview] = useState([]);
    const [buttonText, setButtonText] = useState("Assign");
    const [buttonLoader, setButtonLoader] = useState(false);
    const [activeTabKey, setActiveTabKey] = useState('createNewQuestion');
    const [labQuestions, setLabQuestions] = useState([]);
    const [previousFilters, setPreviousFilters] = useState([]);
    const [selectedLabQuestions, setSelectedLabQuestions] = useState([]);
    const [selectedCurentQuestion, setSelectedCurentQuestion] = useState(null);
    // const [imageLoading, setImageLoading] = useState(false);
    // const [audioLoading, setAudioLoading] = useState(false);
    // const [videoLoading, setVideoLoading] = useState(false);
    const [questionDescription, setQuestionDescription] = useState('');
    const [selectedDueDate, setSelectedDueDate] = useState("");
    const [aiProjectType, setAiProjectType] = useState("");
    const [formValues, setFormValues] = useState({
        aiQuestionTitle: '',
        aiQuestionDescription: ''
    });
    const [selectedProject, setSelectedProject] = useState('default');
    const [grade, setGrade] = useState(null);
    const [topic, setTopic] = useState('');
    const [additionalInfo, setAdditionalInfo] = useState('');
    const [paraphrasedDescription, setParaphrasedDescription] = useState('');
    const [aiQuestionDescriptions, setAiQuestionDescriptions] = useState('');
    const [pagination, setPagination] = useState({ current: 1, pageSize: 5, total: 0, className:'cs-pagination' });


    const handleDueDateChange = (e) => {
        setDueDateChecked(e.target.checked);
    };

    const disabledDate = (current) => {
        // Disable dates before today
        const today = dayjs().startOf('day');
        return current && dayjs(current).isBefore(today, 'day');
    };

    const handleCancel = () => {
        setIsOpenModal(false);
      };

    const columns = [
        {
            title: 'Select',
            dataIndex: 'key',
            className:'poppins-regular',
            render: (text, record) => (
                <Checkbox
                    onChange={(e) => handleRowSelection(e, record)}
                    checked={selectedLabQuestions.some((question) => question.fkActivityId === record._id)}
                />
            ),
        },
        {
            title: 'Title',
            dataIndex: 'title',
            className:'poppins-regular',
        },
        {
            title: 'Type',
            dataIndex: 'projectType',
            className:'poppins-regular',
        },
        {
            title: '',
            dataIndex: 'key',
            className:'poppins-regular',
            render: (text, record) => (
                <img
                src={viewIcon} 
                alt="view"
                onClick={() => {
                    setSelectedProjectView(record);
                    setIsOpenModal(true);
                  }}
                style={{
                    width: 20,
                    height: 20,
                    cursor: 'pointer',
                }}
                />
            ),
        }
    ];

    const handleRowSelection = (e, record) => {
        setSelectedCurentQuestion(record);
        const selectedKey = record._id; // Use a unique identifier as the key

        setSelectedLabQuestions((prevSelectedQuestions) => {
            const updatedSelectedQuestions = [...prevSelectedQuestions];

            if (e.target.checked) {
                // Add the selected key and related information to the array if checked
                const newSelectedQuestion = {
                    fkActivityId: selectedKey,
                    activityName: record.title, // Use the actual property from the record object
                };
                // Check if projectType exists and add it to the new object
                if (record.projectType) {
                    newSelectedQuestion.projectType = record.projectType;
                }
                updatedSelectedQuestions.push(newSelectedQuestion);
            } else {
                // Remove the selected key from the array if unchecked
                const index = updatedSelectedQuestions.findIndex(
                    (question) => question.fkActivityId === selectedKey
                );
                if (index !== -1) {
                    updatedSelectedQuestions.splice(index, 1);
                }
            }

            return updatedSelectedQuestions;
        });
    };


    const handleResourceLevelChange = (value) => {
        setSelectedLevel(value);
    };
    const handleDatePickerChange = (value, dateString) => {
        setSelectedDueDate(dateString)
    };
        
    const handleStudentChange = (value) => {
        setSelectedStudent(value);
    };
    const handleBatchChange = (value) => {
        setSelectedBatch(value);
    };

    const handleClassDivision = (value) => {
        setSingleClassDivisionStream(prevState => ({
            ...prevState,
            ...value
        }));
    };


    const handleStreamChange = (value) => {
        setSingleClassDivisionStream(prevState => ({
            ...prevState,
            ...value
        }));
    };

    const handleGroupChange = (value) => {
        setSelectedGroup(value);
    };

    const assignLabQuestions = async (activityArr, values) => {
        setButtonText("Assigning Lab Question...");
        setButtonLoader(true);
        try {
            // Construct the request object for assigning lab questions
            let assignActivityObj = {
                "activitiesArr": activityArr,
                "crmId": global_var.roleMappingId,
                "teacherName": global_var.user_name,
            };
            if (selectedDueDate) {
                assignActivityObj.dueDate = selectedDueDate;
            }

            // Add assignment details based on the selected assignment method
            if (selectedBatch && selectedBatch.length > 0) {
                setSelectedStudent([]);
                setSelectedClassDivision([]);
                setSelectedGroup([]);
                setSelectedClassDivisionStream([]);
                assignActivityObj.batches = selectedBatch;
                assignActivityObj.studentMappings = [{
                    "type": "batches",
                    "batches": selectedBatch
                }];
            }

            if (selectedStudent && selectedStudent.length > 0) {
                setSelectedBatch([]);
                setSelectedClassDivision([]);
                setSelectedGroup([])
                setSelectedClassDivisionStream([]);
                assignActivityObj.studentMappings = [{
                    "type": "individual-students",
                    "individualStudents": selectedStudent
                }];
            }

            if (selectedGroup && selectedGroup.length > 0) {
                setSelectedStudent([]);
                setSelectedClassDivision([]);
                setSelectedBatch([]);
                setSelectedClassDivisionStream([]);
                assignActivityObj.groups = selectedGroup;
                assignActivityObj.studentMappings = [{
                    "type": "groups",
                    "groups": selectedGroup
                }];
            }

            if (selectedClassDivision && selectedClassDivision.length > 0) {
                setSelectedStudent([]);
                setSelectedBatch([]);
                setSelectedGroup([])
                setSelectedClassDivisionStream([]);
                const studentMapping = selectedClassDivision.map(item => ({
                    type: "class-division",
                    classId: item.fkClassId,
                    className: item.fkClassName,
                    ...(item.fkDivisionId && item.fkDivisionName ? {
                        divisionId: item.fkDivisionId,
                        divisionName: item.fkDivisionName
                    } : {}),
                }));


                assignActivityObj.studentMappings = studentMapping;
            }

            if(selectedClassDivisionStream && selectedClassDivisionStream.length > 0){
                setSelectedStudent([]);
                setSelectedBatch([]);
                setSelectedGroup([])
                setSelectedClassDivision([])
                const studentclassStreamMapping = selectedClassDivisionStream.map(item => ({
                    type: 'class-division',
                    classId: item.fkClassId,
                    className: item.fkClassName,
                    ...(item.fkDivisionId && item.fkDivisionName ? {
                        divisionId: item.fkDivisionId,
                        divisionName: item.fkDivisionName
                    }: {}),

                    ...(item.streamId && item.classStreamName ? {
                        streamId: item.streamId,
                        streamName: item.classStreamName
                    } : {})
                }))

                assignActivityObj.studentMappings = studentclassStreamMapping;

            }

            const responseAssign = await assignLabQuestion(assignActivityObj);

            if (responseAssign.data.statusCode === 200) {
                setButtonText("Done");
                const currentDate = new Date();
                const formattedDate = currentDate.toLocaleDateString('en-US', {
                    month: 'numeric',
                    day: 'numeric',
                    year: 'numeric',
                });
                values.createdDate = formattedDate;
                values.totalAssignedCount = responseAssign.data.totalAssignedCount;
                values.labQuestionsMappingId = responseAssign.data.activity_mapping_id;
                if (selectedLevel){
                    values.fkResourceStudentLevelId = selectedLevel._id
                    values.resourceStudentLevelName = selectedLevel.resourceStudentLevelName
                    values.resourceStudentLevelColor = selectedLevel.resourceStudentLevelColor
                }
                if (!values.questionTitle && !values.aiQuestionTitle) {
                    values.questionTitle = selectedCurentQuestion.title;
                }
                if (!values.projectType && !aiProjectType) {
                    values.projectType = selectedCurentQuestion.projectType;
                }
                if (!values._id) {
                    values._id = selectedCurentQuestion._id;
                }
                if (!values.elements) {
                    values.elements = selectedCurentQuestion.elements;
                }
                // if (!values.maximumMark) {
                //     selectedCurentQuestion.elements.forEach(obj => {
                //         if (obj.value && obj.value.mark && obj.value.mark.totalMark) {
                //             values.maximumMark = obj.value.mark.totalMark;
                //         }
                //     });
                // }

                if (selectedStudent && selectedStudent.length > 0) {
                    values.assignTo = [
                        {
                            "type": "individual-students",
                            "individualStudents": selectedStudent
                        }
                    ]
                }
                if (selectedBatch && selectedBatch.length > 0) {
                    values.assignTo = [
                        {
                            "type": "batches",
                            "batches": selectedBatch
                        }
                    ]
                }
                if (selectedGroup && selectedGroup.length > 0) {
                    values.assignTo = [
                        {
                            "type": "groups",
                            "groups": selectedGroup
                        }
                    ]
                }
                if (selectedClassDivision && selectedClassDivision.length > 0) {
                    values.assignTo = selectedClassDivision.map((item) => {
                        const classDivisionObj = {
                            type: "class-division",
                            classId: item.fkClassId,
                            className: item.fkClassName,
                        };

                        if (item.fkDivisionId) {
                            classDivisionObj.divisionId = item.fkDivisionId;
                            classDivisionObj.divisionName = item.fkDivisionName;
                        }

                        if (item.streamId) {
                            classDivisionObj.streamId = item.streamId;
                            classDivisionObj.streamName = item.streamName;
                        }

                        return classDivisionObj;
                    });
                }

                if(selectedClassDivisionStream && selectedClassDivisionStream.length > 0){
                    values.assignTo = selectedClassDivisionStream.map((item) => {
                        const  classDivisionStream = {
                            type: "class-division",
                            classId: item.fkClassId,
                            className: item.fkClassName,
                        };

                        if (item.fkDivisionId) {
                            classDivisionStream.divisionId = item.fkDivisionId;
                            classDivisionStream.divisionName = item.fkDivisionName;
                        }

                        if (item.streamId) {
                            classDivisionStream.streamId = item.streamId;
                            classDivisionStream.streamName = item.streamName;
                        }

                        return classDivisionStream
                    })
                }


                setButtonLoader(false);
                setSuccessModalVisible(true);
                onCreate(values, 'create');
            } else {
                setButtonText("Assign");
                setButtonLoader(false);
                notification.error({
                    message: 'Error',
                    description: responseAssign.data.message,
                });
            }
        } catch (error) {
            setButtonText("Assign");
            setButtonLoader(false);
            console.error("Error during service request:", error);
            notification.error({
                message: 'Error',
                description: 'An error occurred during the service request.',
            });
        }
    };

    const onFinish = async (values) => {
        setButtonText("Creating Lab Question...");
        setButtonLoader(true);
        if (
            (!selectedBatch || selectedBatch.length === 0) &&
            (!selectedStudent || selectedStudent.length === 0) &&
            (!selectedClassDivision || selectedClassDivision.length === 0) &&
            (!selectedGroup || selectedGroup.length === 0) &&
            (!selectedClassDivisionStream || selectedClassDivisionStream.length === 0)
        ) {
            // Handle the case where none of the assignment methods are selected
            notification.error({
                message: "Error",
                description: "Choose at least one class, division, stream, student, batch, or group, and click '+ Add' to assign it",
            });
            setButtonText("Assign");
            setButtonLoader(false);
            return
        }

        if (activeTabKey === 'createNewQuestion') {
            trackEvent("create_new_lab_assignment_question_button_clicked", {});
            // Logic for creating a new question
            let elements = [];
            let questionArray = [];

            const resourceObj = {
                "companyId": global_var.company_id,
                "fkUserLoginId": global_var.user_login_id,
                "Name": "Lab question",
                "projectType": values.projectType,
                "Icon": "fa-laptop",
                "iconBackground": "rgb(255, 17, 0)",
                "iconColor": "#ffffff",
                "evaluable": true,
                "hideResourse": false,
                "title": values.questionTitle,
                "subjectId": "5903134e6e5694e0619fc82d",  // Directly set to subject CS lab
                "subjectName": "Computer Science",
                "activeFlag": 1,
            }
            if (selectedLevel?._id) {
                resourceObj.resourceStudentLevelName = selectedLevel.resourceStudentLevelName;
                resourceObj.resourceStudentLevelColor = selectedLevel.resourceStudentLevelColor;
                resourceObj.fkResourceStudentLevelId = selectedLevel._id;
            }
            //hard coded sub subject based on project type
            // if (values.projectType === 'python') {
            //     resourceObj.subSubjectName = "Python";
            //     resourceObj.subSubjectId = "5c0ef9129b0452781408b30f";
            // }
            // if (values.projectType === 'html_css') {
            //     resourceObj.subSubjectName = "HTML";
            //     resourceObj.subSubjectId = "5c0efaa29b0452781008b30b";
            // }
            // if (values.projectType === 'vc3') {
            //     resourceObj.subSubjectName = "Visual Coding";
            //     resourceObj.subSubjectId = "65953a8aee6426264537307c";

            // }
            // if (values.projectType === 'sql2') {
            //     resourceObj.subSubjectName = "SQL";
            //     resourceObj.subSubjectId = "65953a2aee6426264537307b";

            // }

            if (values.maximumMark && values.maximumMark > 0) {
                resourceObj.totalMark = values.maximumMark;
            }

            questionArray.push({
                "type": "text",
                "question": questionDescription
            })

            elements.push({
                "displayName": "Title",
                "type": "cours-element-title",
                "value": values.questionTitle

            })
            elements.push({
                "displayName": "Lab question",
                "value": {
                    // "editorName": "tinyMCE",
                    "mark": {
                        "totalMark": values.maximumMark
                    },
                    "type": values.projectType,
                    "question": questionArray,
                    "ques":questionDescription
                }

            })
            resourceObj.elements = elements;
            values.elements = elements;
            // Trigger the parent component's onCreate function
            //service call

            let requestObj = {
                resourceData: resourceObj,
                rmId: global_var.roleMappingId,
                category: "lab-question"
            }

            try {
                const response = await saveMaterialToResource(requestObj);
                const responseData = JSON.parse(response.data);
                if (responseData.statuscode === 200 && responseData.resourceRes._id['$oid']) {
                    setButtonText("Assigning Lab Question...");
                    let selectedLabQuestions = [
                        {
                            "fkActivityId": responseData.resourceRes._id['$oid'],
                            "activityName": responseData.resourceRes.title,
                            'projectType' : values.projectType
                        }
                    ]
                    values._id = responseData.resourceRes._id['$oid'];
                    await assignLabQuestions(selectedLabQuestions, values);

                } else {
                    setButtonText("Assign");
                    setButtonLoader(false);
                    notification.error({
                        message: 'Error',
                        description: responseData.message,
                    });
                }
            } catch (error) {
                setButtonText("Assign");
                setButtonLoader(false);
                console.error("Error during service request:", error);
                notification.error({
                    message: 'Error',
                    description: 'An error occurred during the service request.',
                });
            }
        } else if (activeTabKey === 'pickExistingQuestion') {
            // Logic for assigning an existing question
            trackEvent("assign_existing_lab_assignment_question_button_clicked", {});
            if (selectedLabQuestions.length === 0) {
                setButtonText("Assign");
                setButtonLoader(false);
                notification.error({
                    message: 'Error',
                    description: 'Please select at least one existing question to assign.',
                });
                return;
            } else {
                await assignLabQuestions(selectedLabQuestions, values);
            }
        } else if (activeTabKey === 'aiquestions') {

            if (aiProjectType && !values.projectType) {
                values.projectType = aiProjectType
            }

            let elements = [];
            let questionArray = [];

            const resourceObj = {
                "companyId": global_var.company_id,
                "fkUserLoginId": global_var.user_login_id,
                "Name": "Lab question",
                "projectType": values.projectType,
                "Icon": "fa-laptop",
                "iconBackground": "rgb(255, 17, 0)",
                "iconColor": "#ffffff",
                "evaluable": true,
                "hideResourse": false,
                "title": values.aiQuestionTitle,
                "subjectId": "5903134e6e5694e0619fc82d",  // Directly set to subject CS lab
                "subjectName": "Computer Science",
                "activeFlag": 1,
            }
            if (selectedLevel?._id) {
                resourceObj.resourceStudentLevelName = selectedLevel.resourceStudentLevelName;
                resourceObj.resourceStudentLevelColor = selectedLevel.resourceStudentLevelColor;
                resourceObj.fkResourceStudentLevelId = selectedLevel._id;
            }
            //hard coded sub subject based on project type
            // if (aiProjectType === 'python') {
            //     resourceObj.subSubjectName = "Python";
            //     resourceObj.subSubjectId = "5c0ef9129b0452781408b30f";
            // }
            // if (aiProjectType === 'html_css') {
            //     resourceObj.subSubjectName = "HTML";
            //     resourceObj.subSubjectId = "5c0efaa29b0452781008b30b";
            // }
            // if (aiProjectType === 'vc3') {
            //     resourceObj.subSubjectName = "Visual Coding";
            //     resourceObj.subSubjectId = "65953a8aee6426264537307c";

            // }
            // if (aiProjectType === 'sql2') {
            //     resourceObj.subSubjectName = "SQL";
            //     resourceObj.subSubjectId = "65953a2aee6426264537307b";

            // }

            if (values.aiMaximumMark && values.aiMaximumMark > 0) {
                resourceObj.totalMark = values.aiMaximumMark;
            }

            questionArray.push({
                "type": "text",
                "question": aiQuestionDescriptions
            })

            elements.push({
                "displayName": "Title",
                "type": "cours-element-title",
                "value": values.aiQuestionTitle

            })
            elements.push({
                "displayName": "Lab question",
                "value": {
                    // "editorName": "tinyMCE",
                    "mark": {
                        "totalMark": values.aiMaximumMark
                    },
                    "type": aiProjectType,
                    "question": questionArray,
                    "ques":aiQuestionDescriptions
                }

            })
            resourceObj.elements = elements;
            values.elements = elements;
            // Trigger the parent component's onCreate function
            //service call

            let requestObj = {
                resourceData: resourceObj,
                rmId: global_var.roleMappingId,
                category: "lab-question"
            }

            try {
                const response = await saveMaterialToResource(requestObj);
                const responseData = JSON.parse(response.data);
                if (responseData.statuscode === 200 && responseData.resourceRes._id['$oid']) {
                    setButtonText("Assigning Lab Question...");
                    let selectedLabQuestions = [
                        {
                            "fkActivityId": responseData.resourceRes._id['$oid'],
                            "activityName": responseData.resourceRes.title,
                            'projectType' : values.projectType
                        }
                    ]
                    values._id = responseData.resourceRes._id['$oid'];
                    await assignLabQuestions(selectedLabQuestions, values);

                } else {
                    setButtonText("Assign");
                    setButtonLoader(false);
                    notification.error({
                        message: 'Error',
                        description: responseData.message,
                    });
                }
            } catch (error) {
                setButtonText("Assign");
                setButtonLoader(false);
                console.error("Error during service request:", error);
                notification.error({
                    message: 'Error',
                    description: 'An error occurred during the service request.',
                });
            }
        }
    };

    const renderAssignToSection = () => {
        switch (assignTo) {

            case 'ClassDivisions':
                return (
                    <>
                        <Col span={12}>
                            <ClassDivisionLoader onChange={addClassDivision} selectedClassDivision={selectedClassDivision} isMultiple={true} onRemoveClassDivisions={removeClassDivision}/>
                        </Col>
                        <Col span={18} className="mt-2">
                            <Row>
                                {selectedClassDivision.map((cd, index) => (
                                    <div key={index} className='tagContainer' style={{marginRight: '5px', marginBottom: '8px'}}>
                                        <span style={{ marginRight: '8px' }}>  {`${cd.fkClassName}${cd.fkDivisionName ? `-${cd.fkDivisionName}` : ''}`}</span>
                                        <CloseOutlined onClick={() => removeClassDivision(cd.fkDivisionId)} className='closeIcon' />
                                    </div>
                                ))}
                            </Row>
                        </Col>
                    </>
                );
            case 'Stream':
                return (

                    <>
                        <Row>
                            <Col span={12}>
                                <ClassDivisionLoader onChange={handleClassDivision} />
                            </Col>
                            <Col span={12}>
                                <StreamLoader  onChange={handleStreamChange}  classDivision={singleClassDivisionStream ? singleClassDivisionStream : null}/>
                            </Col>
                        </Row>
                        <Row className='mt-2 mb-3'>
                            <span className='warning-msg'>Select class,division,category and stream then click 'Add Stream' to add it</span>
                        </Row>

                        <Button className='mr-2 mt-2 mb-3 cancel-button'
                            style={{ display: 'inline-flex', verticalAlign: 'middle', cursor: 'pointer'}}
                            onClick={addClassDivisionStream}
                        >
                            + Add Stream
                        </Button>

                        <Col span={18} className="mt-2">
                            <Row>
                                {selectedClassDivisionStream.map((cd, index) => (
                                    <div key={index} className='tagContainer' style={{marginRight: '5px', marginBottom: '8px'}}>
                                        <span className='label'><label>{`${cd.fkClassName}${cd.fkDivisionName ? `${cd.fkDivisionName}` : ''}`}</label>{`${cd.classStreamName ? `- ${cd.classStreamName}` : ''}`}</span>
                                        <CloseOutlined onClick={() => removeClassDivisionStream(index)} className='closeIcon' />
                                    </div>
                                ))}
                            </Row>
                        </Col>
                    </>

                );
            case 'Batches':
                return <BatchLoader onChange={handleBatchChange} />;
            case 'IndividualStudents':
                return <StudentLoader onChange={handleStudentChange} />;
            case 'Groups':
                return <GroupLoader onChange={handleGroupChange} />;
            default:
                return null;
        }
    };

    const handleEditorChange = (content) => {
        setQuestionDescription(content);
    };

    const handleParaphraseChange = (content) => {
        setParaphrasedDescription(content);
    }

    const handleTableChange = (paginate) => {
        fetchLabQuestionResources(paginate.current, paginate.pageSize, previousFilters)
    };

    const fetchLabQuestionResources = async(page, pageSize, selectedFilters)=>{
        try {
            let requestObj = {
                "companyId": global_var.company_id,
                "pageNo": page - 1,
                "limit": pageSize
            };

            if (global_var.role_id !== global_var.ADMIN_ROLE_ID) {
                requestObj['fkUserLoginId'] = global_var.user_login_id;
            }

            // Add searchText filter if available
            if (selectedFilters.searchText && selectedFilters.searchText.length > 0) {
                requestObj["searchText"] = selectedFilters.searchText;
            }

            if (selectedFilters.projectTypes && selectedFilters.projectTypes.length > 0) {
                requestObj["projectTypes"] = selectedFilters.projectTypes;
            }

            const response = await fetchLabQuestionResource(requestObj);
            if (response.data.statusCode === 200) {
                setLabQuestions(response.data.labQuestions);
                setPagination({ current: page, pageSize: pageSize, total: response.data.totalCount, className:'cs-pagination' });
            } else {
                console.error("Failed to fetch lab questions:", response.data.message);
            }
        } catch (error) {
            console.error("Error fetching lab questions:", error);
        }
    }

    const handleFilterChange = async (selectedFilters) => {
        if (isEqual(selectedFilters, previousFilters)) {
            return;
        }
        fetchLabQuestionResources(1, pagination.pageSize, selectedFilters);
        setPreviousFilters(selectedFilters);
    }

    const handleTabChange = async (key) => {
        setActiveTabKey(key);
    };

    useEffect(() => {
        // This code will run when the 'visible' prop changes
        setSelectedStudent([]);
        setSelectedLevel(null);
        setSelectedBatch([]);
        setSelectedGroup([]);
        setSelectedClassDivision([]);
        setSingleClassDivisionStream([])
        setSelectedClassDivisionStream([])
        setAssignTo(null);
        setButtonText("Assign Now");
        setActiveTabKey("createNewQuestion");
        setSelectedProject('default');
        setGrade(null);
        setTopic('');
        setAdditionalInfo('');
        setQuestionDescription('')
        setAiQuestionDescriptions('')
        setParaphrasedDescription('')
        form.resetFields();
    }, [visible, form]);

    const addClassDivisionStream = () => {
        if (singleClassDivisionStream.fkClassId && singleClassDivisionStream.fkDivisionId && singleClassDivisionStream.streamId) {
            if (!selectedClassDivisionStream.some(
                    item => item.fkClassId === singleClassDivisionStream.fkClassId && item.fkDivisionId === singleClassDivisionStream.fkDivisionId &&
                    item.streamId === singleClassDivisionStream.streamId
                )) {
                // Add the singleClassDivisionStream to selectedClassDivisions
                setSelectedClassDivisionStream(prevClassDivisions => [...prevClassDivisions, singleClassDivisionStream]);
                setSelectedClassDivision([])
            }
        }
    }

    const removeClassDivisionStream = (index) => {
        setSelectedClassDivisionStream(prevClassDivisionStream => 
            prevClassDivisionStream.filter((_, i) => i !== index)
        );
    };

    const addClassDivision = (ClassDivision) => {
        if (ClassDivision.fkClassId && ClassDivision.fkDivisionId) {
            if (!selectedClassDivision.some(
                item => item.fkClassId === ClassDivision.fkClassId && item.fkDivisionId === ClassDivision.fkDivisionId)) {
                // Add the ClassDivision to selectedClassDivisions
                setSelectedClassDivision(prevClassDivisions => [...prevClassDivisions, ClassDivision]);
                setSelectedClassDivisionStream([])
            }
        }
    }

    const removeClassDivision = (divisionId) => {
        setSelectedClassDivision(prevClassDivisions => 
          prevClassDivisions.filter((_, i) => _.fkDivisionId !== divisionId)
        );
    };

    const handleAiQuestionData = (values) => {
        const newValues = {
            questionTitle: values.questionTitle || formValues.aiQuestionTitle,
            questionDescription: values.question || formValues.aiQuestionDescription,
            projectType: values.aiProjectType || formValues.aiProjectType,
        };

        setFormValues(newValues);
        form.setFieldsValue(newValues);
        if (newValues.questionDescription) {
            setQuestionDescription(newValues.questionDescription);
            setParaphrasedDescription(newValues.questionDescription);
          }
        if (values.aiProjectType) {
            setAiProjectType(values.aiProjectType)
        }
    };

    useEffect(() => {
        form.setFieldsValue(formValues);
    }, [formValues, form]);
    const [paraphraseVisible, setParaphraseVisible] = useState(false);

  const showModal = () => {
    setParaphraseVisible(true);
  };

  const handleClose = () => {
    setParaphraseVisible(false);
  };

  const openAiModal = () => {
    setIsAiModalOpen(true);
    trackEvent("create_ai_lab_assignment_button_clicked", {});
  };
  const handleAssignToChange = (value) => {
    setAssignTo(value);
    if (value !== 'ClassDivisions') {
        setSelectedClassDivision([]);
    }
};

    return (
        <>
            <Modal
                className='poppins-bold'
                visible={visible}
                title="Assign Lab Question"
                onCancel={onCancel}
                footer={[
                    // <Button key="cancel" onClick={onCancel}>
                    //     Cancel
                    // </Button>,
                    <Button
                        key="ok"
                        type="primary"
                        loading={buttonLoader}
                        onClick={() => {
                            form
                                .validateFields()
                                .then((values) => {
                                    // Set loading to true when the button is clicked
                                    onFinish(values);
                                })
                                .catch((info) => {
                                    console.log('Validate Failed:', info);
                                });
                        }}
                    >
                        {buttonText}
                    </Button>,
                ]}
                style={{ backgroundColor: '#ffffff' }}
                width={'60%'}
            >
                <Form form={form} name="form_in_modal" onFinish={onFinish} layout="vertical">
                    <Tabs activeKey={activeTabKey} onChange={handleTabChange} className='custom-tabs poppins-medium' type="card">
                        <TabPane tab="Create New Question" key="createNewQuestion">
                            <Row align="end">
                                    <Button className='create-button'  style={{color:'#fff',borderColor: "#E96358",}} onClick={openAiModal}>
                                        AI Question
                                        < AiIconRed/>
                                    </Button>
                                    <AiQuestionsModal
                                        isModalOpen={isAiModalOpen}
                                        onCancel={() => setIsAiModalOpen(false)}
                                        handleAiQuestionData={handleAiQuestionData}
                                        selectedProject={selectedProject}
                                        grade={grade}
                                        topic={topic}
                                        additionalInfo={additionalInfo}
                                        setSelectedProject={setSelectedProject}
                                        setGrade={setGrade}
                                        setTopic={setTopic}
                                        setAdditionalInfo={setAdditionalInfo}
                                    />
                            </Row>
                            <Row gutter={12}>
                                <Col span={12}>
                                    <Form.Item className='poppins-regular'
                                        name="questionTitle"
                                        labelCol={{ className: 'poppins-regular' }}
                                        label="Question Title"
                                        extra="Max 60 characters."
                                        rules={
                                            activeTabKey === 'createNewQuestion'
                                                ? [ { required: true, message: 'Please enter the Question Title' },
                                                    { max: 60, message: 'Question Title cannot exceed 60 characters' },
                                                ]
                                                : []
                                        }
                                    >
                                        <Input placeholder="Type the assignment title here. Eg, Lab Question 1" maxLength={60} id="assignment-question-title-input" data-testid="assignment-question-title-input"/>
                                    </Form.Item>

                                </Col>
                                <Col span={12}>
                                    <Form.Item
                                        name="projectType"
                                        label="Project Type"
                                        labelCol={{ className: 'poppins-regular' }}
                                        rules={
                                            activeTabKey === 'createNewQuestion'
                                                ? [{ required: true, message: 'Please select a project type' }]
                                                : []
                                        }
                                    >
                                        <Select defaultValue="default" >
                                            <Option value="default" disabled>
                                                Select a project type
                                            </Option>
                                            {Object.values(projectStacks)
                                                .flatMap((items) =>
                                                    items
                                                        .map((item) => ({
                                                            ...item,
                                                            metaData: getIdeProjectTypeMetaData(item.projectStackName),
                                                        }))
                                                        .filter((item) => item.metaData.showLabQuestion)
                                                )
                                                .map((item) => (
                                                    <Option key={item.projectStackName} value={item.projectStackName}>
                                                        {item.metaData.projectStackDisplayName}
                                                    </Option>
                                                ))}
                                        </Select>
                                    </Form.Item>
                                </Col>
                            </Row>

                            <Form.Item
                                name="questionDescription"
                                label="Question Description"
                                labelCol={{ className: 'poppins-regular' }}
                            >
                                {/* <Input.TextArea rows={4} /> */}
                                <TinyMCEEditor 
                                    onEditorChange={handleEditorChange}
                                    initialValue={paraphrasedDescription}
                                    showAttachButton={true}
                                    >
                                </TinyMCEEditor>
                                
                                {/* <Button class="paraphrase-button" >ddsdsd</Button> */}

                            </Form.Item>
                            { questionDescription && <div className='paraphrase-btn-container'>
                                <Tooltip title='Paraphrase'>
                                    <button className="paraphrase-button" onClick={showModal}>
                                        <AiIconWhite width="15px" height="15px" />
                                    </button>
                                </Tooltip>
                                <ParaphraseAi visible={paraphraseVisible}  handleParaphraseChange={handleParaphraseChange} questionDescription={questionDescription} onClose={handleClose} />
                            </div>

                            }
                            <Row  gutter={[10,10]}>
                                <Col span={8}>
                                    <Form.Item
                                        className='mx-2'
                                        name="maximumMark"
                                        label="Maximum Marks"
                                        labelCol={{ className: 'poppins-regular' }}
                                        rules={[
                                            {
                                                validator: async (_, value) => {
                                                    if (value < 1) {
                                                        throw new Error('Please enter a valid mark');
                                                    }
                                                },
                                                message: 'Please enter a valid mark',
                                            },
                                        ]}
                                    >
                                        <InputNumber 
                                            min={0}
                                            id="assignment-total-mark-input"
                                            data-testid="assignment-total-mark-input"
                                            onKeyDown={(event) => {
                                                if (!/[0-9]/.test(event.key) && event.key !== "Backspace") {
                                                    event.preventDefault(); // Blocks non-numeric input
                                                }
                                            }}
                                        placeholder='Enter mark' style={{width: '100%' }}/>
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item name="dueDate" label="Due Date" labelCol={{ className: 'poppins-regular' }}>
                                        <DatePicker
                                            id="assignment-due-date-picker"
                                            data-testid="assignment-due-date-picker"
                                            onChange={handleDatePickerChange}
                                            disabledDate={disabledDate}
                                            style={{width: '100%' }}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                        <Form.Item name="studentLevel" label="Student proficiency (Optional)" labelCol={{ className: 'poppins-regular' }}>
                                            <ResourceLevel onChange={handleResourceLevelChange}  studentLevelName={selectedLevel ? selectedLevel.resourceStudentLevelName : null}></ResourceLevel>
                                        </Form.Item>
                                </Col>
                            </Row>
                            <Divider className='mt-0 mb-2' style={{backgroundColor:"#D7BEF7"}}/>
                        </TabPane>
                        <TabPane tab="Pick From Existing Question" key="pickExistingQuestion">
                            {/* Render the content for the second tab (blank area) */}
                            <LabQuestionFilter onChange={handleFilterChange} />
                            <Divider />

                            <Table
                                className='mb-4 poppins-regular'
                                columns={columns}
                                dataSource={labQuestions}
                                pagination={pagination}
                                onChange={handleTableChange}
                            />
                        </TabPane>
                    </Tabs>
                    <Form.Item name="assignOption" label="Assign to:" labelCol={{ className: 'poppins-medium' }}>
                        <Radio.Group id="assignment-to-group" data-testid="assignment-to-group" onChange={(e) => handleAssignToChange(e.target.value)} value={assignTo} 
                        >  
                            {!hideClassFilter && (
                                <>
                                    <Radio id="assignment-to-class-divisions" data-testid="assignment-to-class-divisions" className='poppins-regular' value="ClassDivisions">Class divisions</Radio>
                                    {!hideStreamFilter && (
                                        <Radio id="assignment-to-stream" data-testid="assignment-to-stream" className='poppins-regular' value="Stream">Stream</Radio>
                                    )}
                                    <Radio id="assignment-to-groups" data-testid="assignment-to-groups" className='poppins-regular' value="Groups">Groups</Radio>
                                </>
                            )}
                            <Radio id="assignment-to-batches" data-testid="assignment-to-batches" className='poppins-regular' value="Batches">Batches</Radio>
                            <Radio id="assignment-to-individual-students" data-testid="assignment-to-individual-students" className='poppins-regular' value="IndividualStudents">Individual students</Radio>
                        </Radio.Group>
                    </Form.Item>
                    {renderAssignToSection()}
                    {activeTabKey === 'pickExistingQuestion' && (
                        <>
                            <Form.Item name="dueDate" className='mb-2' valuePropName="checked">
                                <Checkbox id="dueDateCheckbox" className='mr-2' onChange={handleDueDateChange} />
                                <label
                                    className='poppins-medium'
                                    style={{ textDecoration: 'underline' }}
                                    htmlFor="dueDateCheckbox"
                                >
                                    Choose a due date
                                </label>
                            </Form.Item>

                            {dueDateChecked && (
                                <Row className="mb-2">
                                    <Col span={11}>
                                        <Form.Item name="dueDate">
                                            <DatePicker
                                                onChange={handleDatePickerChange}
                                                disabledDate={disabledDate}
                                            />
                                        </Form.Item>
                                    </Col>
                                </Row>
                            )}
                        </>
                    )}

                </Form>
            </Modal>
            <SuccessModal isOpen={successModalVisible} onClose={() => setSuccessModalVisible(false)} />
            {isOpenModal && (
            <ModalComponent
                isOpen={isOpenModal}
                handleCancel={handleCancel}
                assignmentObj={selectedProjectView}
            />
            )}
        </>
    );
};

export default CreateAssignment;

